
// window.upcartOnCartLoaded = (cart) => {

//   const stackItems = document.querySelectorAll(".Stack__item");
//   const watermarkImageUrl = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBwgHBgkIBwgKCgkLDRYPDQwMDRsUFRAWIB0iIiAdHx8kKDQsJCYxJx8fLT0tMTU3Ojo6Iys/RD84QzQ5OjcBCgoKDQwNGg8PGjclHyU3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3Nzc3N//AABEIAJQAsQMBIgACEQEDEQH/xAAbAAEAAwEBAQEAAAAAAAAAAAAAAQUGBAcCA//EADcQAQABAwIBCAcHBQEAAAAAAAABAgMEBRFBBhITITFVk9EUFhdTYZLCIiM0NlFzdAdScYHBFf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwD2IAAAAAAAAAAAAAAAAAAAA4BwBAAJAAAAAAAAAAAAAAAAAAAAOAcAQACQAAAAAAAAAAAAAAAAAAADgHAEAAkAAAAAB8110W4iblVNETO29VUQ+lHylsWsjI0i1ft03LdeZtVTVG8T9ioFv6TY9/a+eD0nH9/a+eHD6v6P3Zi+HB6v6P3Zi+HAO70nH9/a+eD0nH9/a+eHD6v6P3Zi+HCKtB0WmN6tOxKY4zNEQDv9Jx/f2vng9Jx/f2vnhwxoGjVRvTpuLMcJi3B6v6P3Zi+HALCi7buTMW7lFcx282qJ2fai0jFx8PlBqdrFs0WbfQ2Z5tEbRv8AaXoAAAABwDgCAASAAAAAAp9d/G6L/N+ipcKfXfxui/zfoqBcOfOzcbT7HT5l6mzb3iOdVxn9Hxqmo42lYleVmXObRT2RHbVP6Q8l5Qa5k63mTevTNNmmfurXCiPMHslFVNdNNdFUVU1RvExO+8Mb/Um1n3cTFnGpuVY0TV0tNv8Au4TPw7VLyP5VVabVThahVNWHPVRVPXNqfJ6XTNNdEVUVRVTMbxMT1TAMt/Tu1nWtLvzmRcptTXE2Yudu23X/AK7GrZbldyrp0mJxcGYuZs9czPXFr/Px+Cw5N8oMfXMXena3k24+9tTPZ8Y+AJwvzNqf7Fn6lwqML8zan+xZ+pbgAAAAHAOAIABIAAAAADP8rcy3p/8A5mXf36O1lc6du2fsVNApOVWiV67hWse3foszbuRXzqqZnfqmP+g815Qa3k63mTevVTTap6rVqJ6qI81Xts23s6ye8rPhT5ns6ye8rPhT5gxK+0nlXqGmaddw7VUVUzG1qqrttT8Fx7OsnvKz4U+Z7OsnvKz4dXmDF3K67lyq5cqmuuqd5qqneZl+uDmX8DJt5OJcm3ctzvEw1/s6ye8rPhT5ns6ye8rPhT5gueR+qxrOo6hmdH0dXRWaa6eG8c7sapneSXJy5oHpXS5NF7pubEcymY22382iAAAAAOAcAQACQAAAAAAAAAAAAAAAAAAADgHAEAAkAAAAAAAAAAAAAAAAAAAA4BwBAAJAAAAAAAAAAAAAAAAAAAAOAcAQACQAAAAAAAAAAAAAAAAAAADgAIAB/9k="; // Replace with your watermark image if needed

//   if (!stackItems.length) {
//     console.warn("❌ No .Stack__item elements found.");
//     return cart;
//   }

//   cart.items.forEach((item, index) => {
//     const stackItem = stackItems[index];
//     if (!stackItem) {
//       console.warn(`❌ No Stack__item at index ${index}`);
//       return;
//     }

//     // Get image wrapper inside Stack__item
//     const wrapper = stackItem.querySelector(".upcart-product-image-wrapper.styles_ProductRow__imageWrapper__");
//     if (!wrapper) {
//       console.warn(`❌ No image wrapper inside Stack__item[${index}]`);
//       return;
//     }

//     // Remove previously injected images if any
//     const existingImage = wrapper.querySelector("img.uploaded-image");
//     if (existingImage) existingImage.remove();

//     // Get uploaded image (if exists)
//     const uploadedImage = item.properties["_Uploaded Image (direct link)"];
//     let imageUrl = null;

//     if (uploadedImage && uploadedImage.startsWith("http")) {
//       imageUrl = uploadedImage;
//       console.log(`✅ Uploaded image found for item ${index}: ${imageUrl}`);
//     } else {
//       imageUrl = watermarkImageUrl;
//       console.log(`⚠️ No uploaded image for item ${index}. Using watermark: ${imageUrl}`);
//     }

//     // Create and insert <img>
//     const img = document.createElement("img");
//     img.src = imageUrl;
//     img.className = "uploaded-image";
//     img.alt = "Product Image";

//     Object.assign(img.style, {
//       width: "100%",
//       maxHeight: "100px",
//       objectFit: "contain",
//       display: "block",
//       borderRadius: "4px",
//       marginBottom: "10px",
//       height: "65px"
//     });

//     wrapper.appendChild(img);
//   });
  

//   return cart;
// };

// window.upcartOnCartLoaded = (cart) => {
//   const stackItems = document.querySelectorAll(".Stack__item");

//   if (!stackItems.length) {
//     console.warn("No .Stack__item elements found.");
//     return cart;
//   }

//   // 🔍 Get the first valid image from the cart to use as fallback
//   let fallbackImageUrl = null;
//   for (const item of cart.items) {
//     const url = item.properties["_Uploaded Image (direct link)"];
//     if (url && url.startsWith("http")) {
//       fallbackImageUrl = url;
//       break;
//     }
//   }

//   // 🔄 Loop through cart items and Stack__items together
//   cart.items.forEach((item, index) => {
//     const stackItem = stackItems[index];
//     if (!stackItem) return;

//     // 📦 Target the child wrapper inside .Stack__item
//     const wrapper = stackItem.querySelector(
//       ".upcart-product-image-wrapper.styles_ProductRow__imageWrapper__"
//     );

//     if (!wrapper) {
//       console.warn(`No image wrapper found in Stack__item ${index}`);
//       return;
//     }

//     // 🧼 Optional: remove any previous injected image if needed
//     const existing = wrapper.querySelector("img.uploaded-image");
//     if (existing) existing.remove();

//     // 📷 Determine image to use
//     const imageUrl =
//       item.properties["_Uploaded Image (direct link)"]?.startsWith("http")
//         ? item.properties["_Uploaded Image (direct link)"]
//         : fallbackImageUrl || "https://via.placeholder.com/100x100?text=No+Image";

//     // 🖼️ Create and insert image tag
//     const img = document.createElement("img");
//     img.src = imageUrl;
//     img.alt = "Uploaded image";
//     img.className = "uploaded-image";

//     Object.assign(img.style, {
//       width: "100%",
//       maxHeight: "100px",
//       objectFit: "cover",
//       borderRadius: "4px",
//       border: "1px solid #ccc",
//       display: "block"
//     });

//     wrapper.appendChild(img);
//   });

//   return cart;
// };
window.upcartOnCartLoaded = (cart) => {
  // Get all image wrapper elements (one per cart item).
  const wrappers = document.querySelectorAll(
    ".upcart-product-image-wrapper.styles_ProductRow__imageWrapper__"
  );

  // Loop over each wrapper and the corresponding cart item.
  wrappers.forEach((wrapper, index) => {
    // Safeguard in case there are more wrappers than items or vice versa
    const item = cart.items[index];
    if (!item) return;

    // Clear any previous content in the wrapper
    wrapper.innerHTML = "";
    // Optional: add custom class to the parent container
    wrapper.parentElement.classList.add("parent-custom-class");

    // Grab the uploaded image URL from the item properties
    let imageUrl = item.properties?.["_Uploaded Image (direct link)"] || "";

    // If there's no valid URL, define a fallback
    if (!imageUrl.startsWith("http")) {
      imageUrl = "https://yourdomain.com/default-image.png";
    }

    // Create and style the <img> element
    const img = document.createElement("img");
    img.src = imageUrl;
    img.className = "uploaded-image";
    Object.assign(img.style, {
      width: "90px",
      height: "auto",
      marginBottom: "10px",
      border: "1px solid #ccc",
      display: "block",
    });

    // Append <img> to this wrapper
    wrapper.appendChild(img);
  });

  // Return the cart if Upcart needs it
  return cart;
};


// window.upcartOnCartLoaded = (cart) => {
//  const container = document.getElementById("custom-images");
//    container.parentElement.classList.add("parent-custom-class");
// container.innerHTML = ""; 

// cart.items.forEach((item, index) => {
//   const imageUrl = item.properties["_Uploaded Image (direct link)"];
//   if (imageUrl) {
//     const div = document.createElement("div");
//     div.className = "uploaded-image";
//     div.style.width = "90px";
//     div.style.height = "148px";
//     div.style.marginBottom = "10px";
//     div.style.backgroundImage = `url('${imageUrl}')`;
//     div.style.backgroundSize = "cover";
//     div.style.backgroundPosition = "center";
//     container.appendChild(div);
//   }
// });
// return cart;
// };


// Modify the cart to include the uploaded image link and preview
// window.upcartModifyCart = (cart) => {
//   // Loop through each item in the cart
//   cart.items.forEach(item => {
//     if (item.properties && item.properties['Uploaded Image']) {
//       const uploadedImageUrl = item.properties['Uploaded Image'];

//       // Add the image link to the 'Uploaded Image' property and make sure it's rendered as HTML
//     "${uploadedImageUrl}) 

//       // Add image preview to the 'Uploaded Image Preview' property and ensure it's rendered as HTML
//       item.properties['Uploaded Image Preview'] = `<img src="${uploadedImageUrl}" alt="Uploaded Image" style="max-width: 150px; margin-top: 10px;">`;
//     }
//   });

//   return cart;
// };


// // Run after the cart is loaded
// window.upcartOnCartLoaded = (cart) => {
//   // Select all .upcart-item-property elements
//   const properties = document.querySelectorAll('.upcart-item-property');

//   properties.forEach(property => {
//     // Find the <span> inside the property
//     const span = property.querySelector('span');
//     if (span && span.innerHTML.includes('Uploaded Image')) {
//       // Unescape HTML entities
//       span.innerHTML = span.innerHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>');

//       // Create a container for the image link and preview
//       const container = document.createElement('div');
//       container.classList.add('uploaded-image-container');

//       // Add the <a> tag (photo link)
//       const photoLink = document.createElement('a');
//       photoLink.href = span.querySelector('a').href;
//       photoLink.target = '_blank';
//       photoLink.textContent = 'Photo';
//       photoLink.classList.add('photo-link');
//       container.appendChild(photoLink);

//       // Add the <img> tag (image preview)
//       const imagePreview = document.createElement('img');
//       imagePreview.src = span.querySelector('img').src;
//       imagePreview.alt = 'Uploaded Image';
//       imagePreview.style.maxWidth = '150px';
//       imagePreview.style.marginTop = '10px';
//       container.appendChild(imagePreview);

//       // Insert the container below the .upcart-item-property
//       property.parentNode.insertBefore(container, property.nextSibling);
//     }
//   });
// };

//  document.addEventListener('upcart:ready', function() {
//     const propertyElements = document.querySelectorAll('.upcart-item-property span');
//     propertyElements.forEach(el => {
//       el.innerHTML = el.innerHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
//     });
//   });
// console.log("evf" ,window.upcartModifyCart) 
// window.upcartModifyCart = (cart) => {
//   const HIDDEN_ITEM_HANDLE = "test-hidden-item";
//   let hiddenQuantity = 0;
 
// const paragraph = document.querySelector('.upcart-item-property span');
//   if (paragraph) {
//     paragraph.innerHTML = paragraph.innerHTML.replace(/&lt;/g, '<');
    
//   }
  
//   // Loop through all items in the cart
//   for (const item of cart.items) {
//     // Check if the item has the uploaded image URL in the properties
//     if (item.properties && item.properties['Uploaded Image']) {
//       window.upcartOnAddToCart()
//       const uploadedImageUrl = item.properties['Uploaded Image']; // Get the image URL

//       // Add the image link and display it in the cart
//       item.properties['Uploaded Image Link'] = `<a href="${uploadedImageUrl}" target="_blank" class="photo-link">Photo</a>`; // Add the clickable link

//       // Add image preview if required
//       item.properties['Uploaded Image Preview'] = `<img src="${uploadedImageUrl}" alt="Uploaded Image" style="max-width: 150px; margin-top: 10px;">`; // Image preview
//     }
//   }

//   // Modify the cart to display the changes (the function should return the updated cart)
//   return cart;
// };


// window.upcartModifyCart = (cart) => {
//   const HIDDEN_ITEM_HANDLE = "test-hidden-item";
//   let hiddenQuantity = 0;

//   // Loop through all items in the cart
//   for (const item of cart.items) {
//     // Check if the item has the uploaded image URL in the properties
//     if (item.properties && item.properties['Uploaded Image']) {
//       const uploadedImageUrl = item.properties['Uploaded Image']; // Get the image URL

//       // Add the image link and display it in the cart
//       item.properties['Uploaded Image Link'] = `<a href="${uploadedImageUrl}" target="_blank" class="photo-link">Photo</a>`; // Add the clickable link

//       // Add image preview if required
//       item.properties['Uploaded Image Preview'] = `<img src="${uploadedImageUrl}" alt="Uploaded Image" style="max-width: 150px; margin-top: 10px;">`; // Image preview
//     }
//   }

//   // Modify the cart to display the changes (the function should return the updated cart)
//   return cart;
// };

// // Example of dynamically inserting the HTML into an element using innerHTML
// function renderCartItemProperties(item) {
//   const imageLinkContainer = document.getElementById('image-link-container');
//   const imagePreviewContainer = document.getElementById('image-preview-container');

//   if (imageLinkContainer && item.properties['Uploaded Image Link']) {
//     imageLinkContainer.innerHTML = item.properties['Uploaded Image Link']; // Render the clickable photo link
//   }

//   if (imagePreviewContainer && item.properties['Uploaded Image Preview']) {
//     imagePreviewContainer.innerHTML = item.properties['Uploaded Image Preview']; // Render the image preview
//   }
// }

// Function to reset variants
window.upcartModifyCart = (cart) => {
  
    for (const item of cart.items) {
        if (item.properties) {
            for (const key in item.properties) {
                if (key === "Uploaded Image") {
                    item.properties["Photo:  Link"] = item.properties[key]; // Rename property
                    delete item.properties[key]; // Remove old key
                }
            }
        }
    }
    return cart; // Return the modified cart object
};

// window.upcartModifyCart = (cart) => {
//     console.log("Original Cart:", cart); // Log the original cart for debugging

//     // Loop through each item in the cart
//     for (const item of cart.items) {
//         // Check if the item has properties
//         if (item.properties) {
//             // Loop through the properties
//             for (const key in item.properties) {
//                 // Check if the property key is "Uploaded Image"
//                 if (key === "Uploaded Image") {
//                     // Extract the image URL
//                     const imageUrl = item.properties[key];
//                     console.log("Image URL:", imageUrl); // Log the extracted image URL

//                     // Replace the property with a hyperlinked "Link"
//                     item.properties["Photo"] = `<a href="${imageUrl}" target="_blank" rel="noopener noreferrer">Link</a>`;

//                     // Remove the old property
//                     delete item.properties[key];

//                     console.log("Modified Item:", item); // Log the modified item
//                 }
//             }
//         }
//     }

//     console.log("Modified Cart:", cart); // Log the modified cart for debugging
//     return cart;
// };

function resetVariants() {
 window.upcartCloseCart()
  
 const scentSelects = document.getElementsByClassName("single-option-selector");
    const quantityInputs = document.getElementsByClassName("quantity-dd");

    if (scentSelects.length > 0) {
        scentSelects[0].selectedIndex = 0;
        console.log("Scent Select Value Set To Default", scentSelects[0]);
    } else {
        console.error("Scent select element not found!");
    }

    if (quantityInputs.length > 0) {
        quantityInputs[0].selectedIndex = 0;
        console.log("Quantity Input Value Set To Default", quantityInputs[0]);
    } else {
        console.error("Quantity input element not found!");
    }
   
    let scentDropdown = document.getElementById('Scent');
    let cropDropdown = document.getElementById('Crop');
    let PcropDropdown = document.getElementById('mainCrop');
    let quantityDropdown = document.getElementById('Quantity-product-template');
    let continueShopping = document.getElementById('CartPopup');

    // Fix: Ensure continueShopping exists before removing class
    if (continueShopping) {
        continueShopping.classList.remove("styles_active__");
    }

    if (scentDropdown) scentDropdown.selectedIndex = 0;
    if (cropDropdown) cropDropdown.selectedIndex = 0;
    if (PcropDropdown) PcropDropdown.selectedIndex = 0;
    if (quantityDropdown) quantityDropdown.selectedIndex = 0;

    // Fix: Properly reset FilePond uploader
    let filepondInstance = document.querySelector('.filepond--root');
    if (filepondInstance && filepondInstance.filepond) {
        filepondInstance.filepond.removeFiles(); // Clears uploaded image
    }

    // Reset custom crop input
    let customCrop = document.getElementById('customCrop');
    if (customCrop) {
        customCrop.value = ''; // Clear custom crop text
        customCrop.disabled = true; // Disable custom crop input
    }

    let lineItemField = document.querySelector('.line-item-property__field');
    if (lineItemField) {
        lineItemField.style.display = 'none'; // Hide custom crop field
    }

    // Reset the Add to Cart button
    let addToCartButton = document.getElementById('btndis');
    if (addToCartButton) {
        addToCartButton.disabled = true; // Disable Add to Cart button
        addToCartButton.textContent = 'Make a Selection'; // Reset button text
    }

    // Select the upload button
    let uploadButton = document.querySelector(".uploadkit-button");

    // Select the uploaded image container
    let thumbnails = document.querySelector(".uploadkit-thumbnails");

    // Select UploadCare menu
    let uploadcareMenu = document.querySelector(".uploadcare--panel__menu");

    // Reset UploadCare's `data-current` attribute
    if (uploadcareMenu) {
        uploadcareMenu.setAttribute("data-current", "upload"); // Reset UploadCare state
    }

    // Remove all uploaded images (clear the preview)
    if (thumbnails) {
        thumbnails.innerHTML = ""; // Clears the image preview
    }

    // Reset the upload button text
    if (uploadButton) {
        uploadButton.textContent = "Upload Your Photo"; // Correctly resets the text
    }

    // Fix: Reset UploadCare properly
    if (window.uploadcare && typeof uploadcare.Widget === "function") {
        let widget = uploadcare.Widget("[role='uploadcare-uploader']");
        widget.value(null); // Clear UploadCare uploaded file
    }
}

// Attach the reset function to the button
document.addEventListener("DOMContentLoaded", function() {
    let resetButton = document.getElementById('resetVariants');
    if (resetButton) {
        resetButton.addEventListener('click', resetVariants);
    }
});
